var exports = {
  "I": "SpoofedCommitWarningBanner__y7XuXc",
};

module.exports = exports;
